var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disponibilite"},[_c('div',{staticClass:"inner",class:{ 'selected': _vm.week.anneeSemaine === _vm.weekSelect },style:(_vm.styles)},[_c('span',[_vm._v(_vm._s(_vm.nbFaceDispo)+" / "+_vm._s(_vm.week.stock))])])])}
var staticRenderFns = []

export { render, staticRenderFns }